import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

export interface SavedTableView {
  id?: number | string;
  name?: string;
  gridId?: string;
}

/** Presentation only: each page retains saved-view loading, persistence and filters. */
@Component({
  selector: 'app-saved-view-picker',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './saved-view-picker.component.html',
  styleUrls: ['./saved-view-picker.component.scss']
})
export class SavedViewPickerComponent {
  @Input() views: SavedTableView[] = [];
  @Input() selected: SavedTableView;
  @Input() dropdown = true;
  @Output() viewChange = new EventEmitter<SavedTableView>();
  @Output() createView = new EventEmitter<void>();
}
